import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import api from "utils/apiService";
import PageHeader from "components/layout/PageHeader";

const OPTIONS = [
  { value: "whoAreWe", label: "من نحن" },
  { value: "terms", label: "الشروط والأحكام" },
  { value: "policy", label: "سياسة الخصوصية" },
];

const AppContentEditor = () => {
  const [title, setTitle] = useState("terms");
  const [content, setContent] = useState({
    contentAr: "",
    contentEn: "",
    id: "",
    title: "",
  });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      setLoading(true);
      const res = await api.get(`/appContent?title=${title}`);
      if (cancelled) return;
      if (res.error) toast.error(res.error);
      else if (res.data) setContent(res.data);
      setLoading(false);
    })();
    return () => {
      cancelled = true;
    };
  }, [title]);

  const handleUpdate = async () => {
    setSaving(true);
    const res = await api.patch(`/appContent`, content);
    setSaving(false);
    if (res.error) toast.error(res.error);
    else toast.success("تم تحديث المحتوى بنجاح");
  };

  return (
    <div className="mt-6">
      <PageHeader
        title="تحديث المحتوى"
        subtitle="حرر النصوص بالعربي والإنجليزي"
        filters={
          <select
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            className="rounded-lg border border-border bg-white px-3 py-2 text-sm text-navy-700 outline-none dark:border-navy-700 dark:bg-navy-800 dark:text-white"
          >
            {OPTIONS.map((o) => (
              <option key={o.value} value={o.value}>
                {o.label}
              </option>
            ))}
          </select>
        }
      />
      <div className="flex flex-col gap-5 rounded-2xl border border-border-muted bg-white p-5 shadow-card dark:border-navy-700 dark:bg-navy-800">
        <label className="flex flex-col gap-1">
          <span className="text-sm font-medium text-gray-700 dark:text-gray-200">
            المحتوى بالعربي
          </span>
          <textarea
            value={content.contentAr || ""}
            onChange={(e) =>
              setContent({ ...content, contentAr: e.target.value })
            }
            rows={6}
            disabled={loading}
            className="rounded-lg border border-border bg-surface-muted px-3 py-2 text-sm text-navy-700 outline-none transition focus:border-info-500 focus:bg-white dark:border-navy-600 dark:bg-navy-900 dark:text-white"
          />
        </label>
        <label className="flex flex-col gap-1">
          <span className="text-sm font-medium text-gray-700 dark:text-gray-200">
            المحتوى بالإنجليزي
          </span>
          <textarea
            value={content.contentEn || ""}
            onChange={(e) =>
              setContent({ ...content, contentEn: e.target.value })
            }
            rows={6}
            disabled={loading}
            className="rounded-lg border border-border bg-surface-muted px-3 py-2 text-sm text-navy-700 outline-none transition focus:border-info-500 focus:bg-white dark:border-navy-600 dark:bg-navy-900 dark:text-white"
          />
        </label>
      </div>
      <div className="mt-4 flex justify-end">
        <button
          type="button"
          onClick={handleUpdate}
          disabled={loading || saving}
          className="rounded-lg bg-info-600 px-6 py-2 text-sm font-semibold text-white shadow-card transition hover:bg-info-700 disabled:opacity-60"
        >
          {saving ? "جاري التحديث" : "تحديث"}
        </button>
      </div>
    </div>
  );
};

export default AppContentEditor;
